import { render, staticRenderFns } from "./mensagem.vue?vue&type=template&id=0775920a"
import script from "./mensagem.ts?vue&type=script&lang=js&external"
export * from "./mensagem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0775920a')) {
      api.createRecord('0775920a', component.options)
    } else {
      api.reload('0775920a', component.options)
    }
    module.hot.accept("./mensagem.vue?vue&type=template&id=0775920a", function () {
      api.rerender('0775920a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/mensagem/mensagem.vue"
export default component.exports